<div class="access-denied">
    <h1> Access Denied</h1>
    <p> You do not have permission to view this page</p>
    <a routerLink=" /">Return to Main Page</a>
</div>